import React, { useState, useRef } from 'react'
import { bind } from '@src/utils'
import Main from '@src/components/main'
import { DataImportViewModel, IDataImportViewModel } from './dataImport.view-model'
import { categoryMap, Category } from './config'
import './style.scss'
import { useDialog } from '@src/components/dialog'
import { Button, Form } from 'react-bootstrap'

function DataImport({ category, importFile, shippingNo, setShippingNo, handleCarInfoDelBtnOnClick }: IDataImportViewModel) {
  const title = categoryMap[category as Category]
  const [xlsxFile, setXlsxFile] = useState<File | null>()
  const { dialog } = useDialog()
  const inputRef = useRef<HTMLInputElement>(null)

  const handleFileOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) setXlsxFile(file)
  }

  const handleOnSubmit = async () => {
    if (!xlsxFile) {
      dialog.alert({
        title: '提醒', message: '尚未選擇檔案'
      })
      return
    }
    await importFile(xlsxFile)
    setXlsxFile(null)
    if (inputRef.current) inputRef.current.value = ''
  }

  const handleShippingNoOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setShippingNo(e.target.value)
  }

  return (
    <Main pageTitle={title}>
      <div className='data-import'>
        <label>
          <span>{`上傳${title}`}</span>
          <div className='input-wrap'>
            <input
              className='form-input'
              placeholder='檔案名稱'
              type='file'
              onChange={handleFileOnChange}
              ref={inputRef}
            />
          </div>
          <div className='btn-wrap'>
            <button onClick={handleOnSubmit}>
              確認上傳
            </button>
          </div>
        </label>
      </div>
      {
        category === 'car-info' && (
          <div className='data-import-other'>
            <Form.Group className='mb-3'>
              <Form.Label>依船次編號刪除整船資料</Form.Label>
              <Form.Control value={shippingNo} onChange={handleShippingNoOnChange} placeholder='請輸入編號' />
            </Form.Group>
            <Button variant='danger' onClick={() => handleCarInfoDelBtnOnClick(shippingNo)}>刪除</Button>
          </div>
        )
      }
    </Main>
  )
}

export default bind(DataImport, DataImportViewModel)
